"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
var Location_1 = __importDefault(require("./Location"));
var Token = /** @class */ (function () {
    /** @constructor */
    function Token(id, text, line, position) {
        this.id = id;
        this.text = text;
        this.location = new Location_1.default(line, position);
    }
    Token.prototype.toString = function () {
        return "Token(\"" + this.text + "\")";
    };
    return Token;
}());
exports.Token = Token;
//# sourceMappingURL=Token.js.map